import React from 'react'
import styled from '@emotion/styled'
import { LoadingImage } from './Basics'

import { fontSize2XSmall, fontWeightBold, fontFamilyOpenSans } from '../../constants/principles'
import { breakpoints } from '../../constants/index'
import ProgressBar from '../progressBar/progressBar'

const KbbIcoSvg = __PATH_PREFIX__ + '/Landing/KBBICO-Logo-rgb.svg'

export default ({ urlState, displayImages, year, make, model, images, nextDisabled, errorFunc, updateGlobalState, trim, autoCheckData, vinResults, experienceState, globalState, mileage }) => {
  const useComponentFunnelBreadcrumb = globalState?.isBreadcrumbWebComponentEnabled

  return (
    <>
      {!useComponentFunnelBreadcrumb && (
        <IconDiv>
          <FlexDiv>
            <LoadingImage displayImages={displayImages} images={images} />
            <div>
              <TextDiv fontWeight={fontWeightBold}>Instant Cash Offer</TextDiv>
              <TextDiv>
                {year ? year.displayName : ''} {make ? make.displayName : ''} {model ? model.displayName : ''} {trim ? trim.displayName : ''}
              </TextDiv>
            </div>
          </FlexDiv>
          <StyledICODiv>
            <StyledImg itemProp="image" src={KbbIcoSvg} alt="KBB.com Instant Cash Offer" />
          </StyledICODiv>
        </IconDiv>
      )}
      <ProgressBar {...{ urlState, year, make, model, trim, nextDisabled, errorFunc, updateGlobalState, autoCheckData, vinResults, experienceState, globalState, mileage }} />
    </>
  )
}

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const IconDiv = styled(FlexDiv)`
  font-family: ${fontFamilyOpenSans};
  padding-top: 16px;
  padding-bottom: 16px;
  align-items: center;
  width: 100%;
`
const StyledImg = styled.img`
  max-width: 160px;
`
const StyledICODiv = styled.div`
  width: 200px;
  display: none;
  @media (min-width: ${breakpoints.mid}px) {
    display: block;
  }
`

const TextDiv = styled.div`
  padding-left: 4px;
  font-size: ${fontSize2XSmall};
  font-weight: ${p => p.fontWeight};
`
